import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { MI_CAPABILITIES } from '../capabilities';
import { MI_FIELD_KEYS } from '../fields';
import { MI_MODULES } from '../modules';
import { miMigrations, normalizeMiPresetToSpec } from './migrations';
import { buildMiDisplayDescriptors, buildMiResourceConfigs, pickMiPresetFields, serializeMiApiBody } from './projections';
import { type MiApiPayload, type MiSpec, MiSpecSchema } from './schema';
import { miFromForm, miGetInitialFormValues, miToForm } from './spec';

const miBaseHeadless = createDeployPluginHeadless<MiSpec, MiApiPayload, (typeof MI_FIELD_KEYS)[number]>({
  code: 'ModelInstance',
  fieldKeys: MI_FIELD_KEYS,
  modules: MI_MODULES,
  capabilities: MI_CAPABILITIES,
  schema: MiSpecSchema,
  fromForm: (values, ctx) => miFromForm(values, ctx, { elevateSharedEnvAndService: true }),
  toForm: miToForm,
  getInitialFormValues: miGetInitialFormValues,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeMiApiBody,
      skuPreset: pickMiPresetFields,
      buildDisplayDescriptors: (spec, ctx) => buildMiDisplayDescriptors(spec, ctx),
      skuResources: buildMiResourceConfigs,
    },
  },
  migrations: miMigrations,
});

export const miPipelineKernel = miBaseHeadless.pipeline;

/** SKU preset（扁平表单或完整 MiSpec）规范化后再 parse */
export const miPipeline = {
  ...miPipelineKernel,
  parseSpec: (input: unknown) => miPipelineKernel.parseSpec(normalizeMiPresetToSpec(input)),
};

export const miHeadless = {
  ...miBaseHeadless,
  pipeline: miPipeline,
};

export { buildMiDeliveryMetadata, buildMiOrderDeliveryMetadata, buildModelInstanceOrderDeliveryMetadataBody } from './deliveryMetadata';
export type { BuildMiDeliveryMetadataInput, BuildMiOrderDeliveryMetadataContext, ModelInstanceDeliveryMetadata } from './deliveryMetadata';
export { filterMiSpecByEnabledModules, isMiModuleEnabled } from './enabledModules';
export {
  formToPayload,
  getModelSizeStorageMismatchErrorKey,
  getModelSourceType,
  prepareModelInstanceSubmit,
  readModelInstanceSpecFromForm,
  sanitizeModelSource,
  serializeModelForApi,
  validateMaasStorage,
} from './payload';
